import IItemOrderStatusViewModel from "interfaces/IItemOrderStatusViewModel";

const DetailsTemplate = ({ quantity, item, size }: IItemOrderStatusViewModel): any => {
  const builtMessage = () => {
    let result : string = `${quantity} x ${item}`;
    if (size && size.trim().length > 0) {
      result += ` (${size.trim()})`;
    }
    return result;
  };

  return (
    <>
      <span className="fw-bold">{builtMessage()}</span>
    </>
  );
};
export default DetailsTemplate;
